import { List, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import { ScrollRotate } from 'react-scroll-rotate';

interface Props {
    dataFilters: any;
    filter: any;
}

const LabelsFilters = (props: Props) => {
    const history = useHistory();
    const { dataFilters } = props

    return (
        <div className="labels-filters-listing">

            <List
                dataSource={dataFilters}
                renderItem={(item: any) =>
                    <List.Item className={props.filter === item.filter ? "selected" : "not-selected"} key={`filterLabel_${item.id}`} onClick={() => history.push(`/labels?name=${item.filter}`)} >
                        <Typography.Text>{item.filter}</Typography.Text>
                    </List.Item>
                }
            />
        </div>
    )
}

export default LabelsFilters;